// need to add the note-rendering logic to the search rendering logic. the exact logic (copy paste) to show the search results just like the notes. 



import React, { useState, useEffect, useRef } from 'react';
import { auth, db } from '../firebaseConfig';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { firestore,  app } from '../firebaseConfig'; 
import {
  collection,
  query,
  doc,
  getDoc,
  getDocs, 
  orderBy,
  updateDoc,
  deleteDoc,
  onSnapshot,
  where,
  addDoc,
  arrayUnion, 
} from 'firebase/firestore';
import './Database.css'; 
import { algoliasearch } from 'algoliasearch';
import { saveToGallery, formatSaveMessage } from '../utils/saveToGallery';







const user = auth.currentUser;
const ownerName = user?.displayName || user?.email || "Unknown";
const storage = getStorage(app, "gs://coldwire-f7262.firebasestorage.app");






export default function Database({ sidebarVisible }) {
  const [notes, setNotes] = useState([]);
  const [search, setSearch] = useState('');
  const [editedCommentFlags, setEditedCommentFlags] = useState([]);
  const [editedNoteFlags, setEditedNoteFlags] = useState([]);
  const [filteredNotes, setFilteredNotes] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [tab, setTab] = useState('Person');
  const [ownerName, setOwnerName] = useState("");
  const [expandedNoteId, setExpandedNoteId] = useState(null);
  const [editModeId, setEditModeId] = useState(null); 
  const [editedNoteData, setEditedNoteData] = useState(null); // local changes
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [formFlags, setFormFlags] = useState([]);
  const [customCode, setCustomCode] = useState('');
  const [profileLoaded, setProfileLoaded] = useState(false);
  const [customDesc, setCustomDesc] = useState('');
  const [userId, setUserId] = useState("");
  const [userRank, setUserRank] = useState('');
  const [userAgency, setUserAgency] = useState("");
  const [userState, setUserState] = useState('');
  const [visibleDescriptions, setVisibleDescriptions] = useState({});
  const [commentCustomCode, setCommentCustomCode] = useState('');
  const [commentCustomDesc, setCommentCustomDesc] = useState('');
  const [newCommentText, setNewCommentText] = useState("");
  const [expandedNotes, setExpandedNotes] = useState({});
  const [visibleCommentNoteId, setVisibleCommentNoteId] = useState(null);
  const [editingComment, setEditingComment] = useState(null); // { noteId, index }
  const [editedCommentText, setEditedCommentText] = useState('');
  const [newCommentFlags, setNewCommentFlags] = useState([]);
  const [noteComments, setNoteComments] = useState({});
  const [visibleFlagDescriptions, setVisibleFlagDescriptions] = useState({});
  const [customFlag, setCustomFlag] = useState({ code: '', description: '' });
  const flagRefs = useRef({});
  const commentUnsubscribers = useRef({});
  const [entryState, setEntryState] = useState(userState || '');
  const [userInput, setUserInput] = useState('');
  const [searchField, setSearchField] = useState('fullName'); // default search field
  const [searchResults, setSearchResults] = useState([]);
  const [searchStreet, setSearchStreet] = useState('');
  const [searchCity, setSearchCity] = useState('');
  const [searchFirstName, setSearchFirstName] = useState('');
  const [searchLastName, setSearchLastName] = useState('');
  const [searchDob, setSearchDob] = useState('');
  const [searchPlate, setSearchPlate] = useState('');
  const [searchPlateState, setSearchPlateState] = useState('');
  const [editSearchResultId, setEditSearchResultId] = useState(null);
  const [editedSearchResultData, setEditedSearchResultData] = useState({});
  const [editedSearchResultFlags, setEditedSearchResultFlags] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [modalEntryState, setModalEntryState] = useState(userState);
  const [hasSearched, setHasSearched] = useState(false);
  const [commentCounts, setCommentCounts] = useState({});
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [isCreatingNote, setIsCreatingNote] = useState(false);
  const [isSavingNote, setIsSavingNote] = useState(false);
  const [deletingNoteId, setDeletingNoteId] = useState("");
  const [commentSubmittingNoteId, setCommentSubmittingNoteId] = useState("");
  const [isSavingComment, setIsSavingComment] = useState(false);
  const [deletingCommentId, setDeletingCommentId] = useState("");
  const [editedFiles, setEditedFiles] = useState([]);
  const [editedPreviewUrls, setEditedPreviewUrls] = useState([]);
  const [selectedPreviewUrl, setSelectedPreviewUrl] = useState(null);
  const [selectedPreviewType, setSelectedPreviewType] = useState(null);
  const [modalImage, setModalImage] = useState(null);








const handleAlgoliaSearch = async () => {
  console.log('🔍 handleAlgoliaSearch triggered:', entryState, searchQuery);

  if (!searchQuery.trim()) {
    console.log('🚫 Empty search query. Exiting.');
    setSearchResults([]);
    return;
  }

  try {
    const client = algoliasearch(
      process.env.REACT_APP_ALGOLIA_APP_ID,
      process.env.REACT_APP_ALGOLIA_SEARCH_API_KEY
    );
    console.log('🔑 Algolia client created');

  const filters = entryState ? `entryState:"${entryState}"` : undefined;
console.log("📦 Using filters:", filters);

// ✅ Wait until after res is available
const res = await client.search([
  {
    indexName: 'Database',
    query: searchQuery,
    params: {
      filters: filters,
    },
  },
]);

const hits = res.results?.[0]?.hits || [];
console.log('📊 Raw hits:', hits);

hits.forEach((hit, i) => {
  
});

    const docIds = res.results[0].hits.map(hit => {
  console.log('🔍 Algolia hit:', {
    objectID: hit.objectID,
    path: hit.path,
    entryState: hit.entryState,
    fields: Object.keys(hit),
  });
  return hit.objectID;
});

    if (docIds.length === 0) {
      console.log('⚠️ No matching docs found.');
      setSearchResults([]);
      setHasSearched(true);
      return;
    }

    const docRefs = docIds.map(id => doc(firestore, 'sharedNotes', id));

const snapshots = await Promise.all(docRefs.map(ref => getDoc(ref)));


const notes = snapshots
  .filter(snap => snap.exists())
  .map(snap => {
    const hit = res.results[0].hits.find(h => h.objectID === snap.id);
    // Preserve highlights in-memory for UI
  return sanitizeNoteForFirestore(
  {
    id: snap.id,
    ...snap.data(),
    _highlightResult: hit?._highlightResult || null,
    _rankingInfo: hit?._rankingInfo || null,
  },
  true
);
  });

    setSearchResults(notes);
    sessionStorage.setItem('searchResults', JSON.stringify(notes));
    setHasSearched(true);
  } catch (error) {
    console.error('❌ Algolia search error:', error);
    alert('There was a problem running the Algolia search.');
  }
};

// 🧹 Deep sanitizer: removes Algolia/UI-only metadata before saving to Firestore
const sanitizeNoteForFirestore = (data, preserveHighlights = false) => {
  if (!data || typeof data !== "object") return data;
  if (Array.isArray(data)) return data.map(d => sanitizeNoteForFirestore(d, preserveHighlights));

  const cleaned = {};
  for (const [key, value] of Object.entries(data)) {
    if (
      !preserveHighlights &&
      ["_highlightResult","_rankingInfo","matchLevel","matchedWords","fullyHighlighted","value"].includes(key)
    ) continue;

    cleaned[key] = typeof value === "object" && value !== null
      ? sanitizeNoteForFirestore(value, preserveHighlights)
      : value;
  }
  return cleaned;
};




  const [personForm, setPersonForm] = useState({
  firstName: '',
  middleName: '',
  lastName: '',
  dob: '',
  age: '',
  race: '',
  sex: '',
  streetAddress: '',
  city: '',
  addressState: '',
  dl: '',
  dlState: '',
  phone: '',
  gangAffiliated: false,
  gangName: '',
  knownAssociates: [],
  narrative: ''
});

const [vehicleForm, setVehicleForm] = useState({
  make: '',
  model: '',
  plate: '',
  plateState: '',
  color: '',
  owner: '',
  narrative: ''
});

const [placeForm, setPlaceForm] = useState({
  address: '',
  owner: '',
  occupants: [],
  narrative: ''
});

	
	 const states = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut",
    "Delaware", "Florida", "Georgia", "Hawaii", "Idaho", "Illinois", "Indiana",
    "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland", "Massachusetts",
    "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska",
    "Nevada", "New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina",
    "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island",
    "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
    "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
  ];


const renderStateDropdown = () => {
  return (
    <select
      id="entryState"
      className="form-control"
      value={entryState}
      onChange={(e) => setEntryState(e.target.value)}
    >
      <option value="">Select State</option>
      {states.map((state) => (
        <option key={state} value={state}>
          {state}
        </option>
      ))}
    </select>
  );
};



	const renderModalStateDropdown = () => (
  <select
    id="modalEntryState"
    className="form-control state-dropdown"   // 👈 added here
    value={modalEntryState}
    onChange={(e) => setModalEntryState(e.target.value)}
  >
    <option value="">Entry State</option>
    {states.map((state) => (
      <option key={state} value={state}>
        {state}
      </option>
    ))}
  </select>
);



const fetchCommentCount = async (noteId) => {
  try {
    const snapshot = await getDocs(collection(db, "sharedNotes", noteId, "comments"));
    setCommentCounts(prev => ({
      ...prev,
      [noteId]: snapshot.size
    }));
  } catch (err) {
    console.error("Failed to fetch comment count:", err);
  }
};



const fetchNotes = async () => {
  try {
    const q = query(collection(db, 'sharedNotes'));
    const snapshot = await getDocs(q);
    const userNotes = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    userNotes.sort((a, b) => {
      const timeA = a.timestamp?.seconds || 0;
      const timeB = b.timestamp?.seconds || 0;
      return timeB - timeA;
    });

    setNotes(userNotes);
    setFilteredNotes(userNotes);
  } catch (error) {
    console.error("Failed to fetch notes:", error);
  }
};

// ✅ useEffect is standalone now
useEffect(() => {
  fetchNotes();
}, []);


// 🔄 Fetch comment counts when notes or searchResults change
useEffect(() => {
  const currentNotes = searchResults.length > 0 ? searchResults : notes;
  currentNotes.forEach(note => {
    fetchCommentCount(note.id);
  });
}, [searchResults, notes]);


	useEffect(() => {
  if (userState) {
    setEntryState(userState);
  }
}, [userState]);




  const navigate = useNavigate(); // from react-router-dom

const handleViewProfile = (userId) => {
  navigate(`/profile/${userId}`);
};


  const flagOptions = {
  Person: [
    { code: 'AWC', description: 'Approach With Caution' },
    { code: 'WARR', description: 'Warrant' },
    { code: 'VLNT', description: 'Violent' },
    { code: 'FLN', description: 'Fellon' },
    { code: 'KTBA', description: 'Known to be armed' },
    { code: 'DV-P', description: 'Domestic Violence Perpetrator' },
    { code: 'DV-V', description: 'Domestic Violence Victim' },
    { code: 'UNCO', description: 'Un Cooperative' },
    { code: 'PRST', description: 'Prostitution' },
  ],
  Vehicle: [
    { code: 'STLN', description: 'Stolen' },
    { code: 'CRIM', description: 'Criminal Involvement' },
    { code: 'TRAF', description: 'Trafficking' },
  ],
  Place: [
    { code: 'DRGS', description: 'Drug Sales' },
    { code: 'GANG', description: 'Gang Hangout' },
    { code: 'WPN', description: 'Weapons' },
    { code: 'NOIS', description: 'Noise Complaints' },
    { code: 'DV', description: 'Domestic Violence' },
  ],
};


const allFlagOptions = Object.values(flagOptions).flat();


   const handleSelectPredefinedFlag = (e) => {
  const selectedCode = e.target.value;
  if (!selectedCode) return;

  const existing = formFlags.find(f => f.code === selectedCode);
  if (existing) return;

  const selectedFlag = flagOptions[tab].find(f => f.code === selectedCode);
  if (selectedFlag) {
    setFormFlags([...formFlags, selectedFlag]);
  }
};


const handleAddCustomFlag = () => {
  if (!customCode || !customDesc) return;

  const code = customCode.toUpperCase().slice(0, 4);
  const exists = formFlags.some(f => f.code === code);
  if (exists) return;

  setFormFlags([...formFlags, { code, description: customDesc }]);
  setCustomCode('');
  setCustomDesc('');
};

const handleRemoveFlag = (index) => {
  const updated = [...formFlags];
  updated.splice(index, 1);
  setFormFlags(updated);
};


  const handleAddCustomCommentFlag = () => {
  if (!commentCustomCode || !commentCustomDesc) return;

  const newFlag = {
    code: commentCustomCode,
    description: commentCustomDesc
  };

  setNewCommentFlags(prev => [...prev, newFlag]);
  setCommentCustomCode('');
  setCommentCustomDesc('');
};


const toggleComments = (noteId) => {
  setExpandedNotes(prev => ({
    ...prev,
    [noteId]: !prev[noteId]
  }));
};


  const toggleCommentFlag = (flag) => {
  setNewCommentFlags(prev =>
    prev.includes(flag) ? prev.filter(f => f !== flag) : [...prev, flag]
  );
};

  
  



 useEffect(() => {
  const auth = getAuth();

  const unsubscribe = onAuthStateChanged(auth, async (user) => {
    if (user) {
      const userRef = doc(firestore, "users", user.uid);
      try {
        const userSnap = await getDoc(userRef);
        if (userSnap.exists()) {
          const data = userSnap.data();
          console.log("✅ Loaded profile:", data);

        setUserId(user.uid);  // 🔒 important
setOwnerName(data.firstInitialLastName || data.displayName || user.email || "");
setUserRank(data.rank || data.Rank || "");
setUserAgency(data.agency || data.agncy || "");
setUserState(data.state || ''); // 🆕 Load user's home state
setProfileLoaded(true);

  const savedResults = sessionStorage.getItem('searchResults');
  if (savedResults) {
    setSearchResults(JSON.parse(savedResults));
  }

        } else {
          console.warn("⚠️ No user document found in Firestore.");
        }
      } catch (err) {
        console.error("🔥 Error loading user profile:", err);
      }
    }
  });

  return () => unsubscribe(); // cleanup
}, []);


   
  useEffect(() => {
  const handleClickOutside = (event) => {
    for (const key in flagRefs.current) {
      if (flagRefs.current[key] && !flagRefs.current[key].contains(event.target)) {
        setVisibleFlagDescriptions(prev => ({
          ...prev,
          [key]: false
        }));
      }
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => {
    document.removeEventListener('mousedown', handleClickOutside);
  };
}, []);


 useEffect(() => {
  const term = search.toLowerCase();

  const filtered = notes.filter(note => {
    // 🔵 Only show notes matching current tab
    if (note.type !== tab) return false;

    const noteContent = Object.values(note).join(' ').toLowerCase();
    const gangName = note.gangName?.toLowerCase() || '';

    const commentMatches = (noteComments[note.id] || []).some(comment => {
      const textMatch = comment.text?.toLowerCase().includes(term);
      const ownerMatch = comment.ownerName?.toLowerCase().includes(term);
      const flagMatch = (comment.flags || []).some(flag =>
        typeof flag === 'string'
          ? flag.toLowerCase().includes(term)
          : (flag.code?.toLowerCase().includes(term) || flag.description?.toLowerCase().includes(term))
      );
      return textMatch || ownerMatch || flagMatch;
    });

    return noteContent.includes(term) || gangName.includes(term) || commentMatches;

  });

  setFilteredNotes(filtered);
}, [search, notes, noteComments, tab]); // 🟢 Add 'tab' as a dependency



	useEffect(() => {
  if (modalVisible) {
    setModalEntryState(userState);
  }
}, [modalVisible, userState]);

	


	const highlightMatches = (text, searchTerm) => {
  if (!searchTerm) return text;
  const regex = new RegExp(`(${searchTerm})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === searchTerm.toLowerCase() ? (
      <mark key={index} style={{ backgroundColor: 'yellow' }}>{part}</mark>
    ) : (
      part
    )
  );
};

	

	const highlightWithFuzzy = (fieldValue, note, fieldName) => {
  const highlightObj = note._highlightResult?.[fieldName];
  if (highlightObj && highlightObj.value) {
    // Algolia puts <em>…</em> around matches (exact AND fuzzy)
    // We'll style them as yellow highlights
    return (
      <span
        dangerouslySetInnerHTML={{
          __html: highlightObj.value
            .replace(/<em>/g, '<mark style="background:yellow">')
            .replace(/<\/em>/g, '</mark>')
        }}
      />
    );
  }

  // Fallback if Algolia didn’t return highlights
  return fieldValue;
};





  const calculateAge = (dob) => {
    const birth = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birth.getFullYear();
    const m = today.getMonth() - birth.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
      age--;
    }
    return age;
  };


    // --- blank-note helpers ---
const isBlank = (v) => {
  if (v === undefined || v === null) return true;
  return String(v).trim() === '';
};

const cleanedArray = (arr) =>
  Array.isArray(arr)
    ? arr.map(x => String(x ?? '').trim()).filter(Boolean)
    : [];

const isPersonNoteEmpty = (p) => {
  // text-ish fields that count as content
  const fields = [
    p.firstName, p.middleName, p.lastName,
    p.dob, p.race, p.sex,
    p.streetAddress, p.city, p.addressState, p.addressZip,
    p.dl, p.dlState, p.phone,
    p.narrative,
    p.gangAffiliated ? p.gangName : ''
  ];
  const anyText = fields.some(v => !isBlank(v));
  const anyAssoc = cleanedArray(p.knownAssociates).length > 0;
  return !(anyText || anyAssoc);
};



  const handleAddNote = async () => {
  if (isCreatingNote) return;
  console.log("handleAddNote triggered");

  const noteData =
    tab === 'Person' ? personForm :
    tab === 'Vehicle' ? vehicleForm :
    placeForm;

  if (!userId) {
    console.error("User not logged in.");
    return;
  }

  if (!profileLoaded) {
    console.warn("Profile not yet loaded.");
    alert("Still loading your profile info. Please wait.");
    return;
  }

  if (!ownerName) console.warn("Missing display name.");
  if (!userRank) console.warn("Missing rank.");
  if (!userAgency) console.warn("Missing agency.");

  console.log("noteData before validation:", noteData);

  // generic guard (kept as-is)
  const hasContent = Object.values(noteData).some(
    val => (Array.isArray(val) ? val.length > 0 : val?.toString().trim() !== "")
  );
  if (!hasContent) {
    alert("The note is empty.");
    return;
  }

  // Person-only normalization + stricter blank check
  if (tab === 'Person') {
    noteData.gangAffiliated = noteData.gangAffiliated || false;
    noteData.gangName = noteData.gangAffiliated ? noteData.gangName || '' : '';

    if (typeof noteData.knownAssociates === 'string') {
      noteData.knownAssociates = noteData.knownAssociates.split(',').map(s => s.trim());
    }
    noteData.knownAssociates = cleanedArray(noteData.knownAssociates);

    if (isPersonNoteEmpty(noteData)) {
      alert('Please fill at least one field before saving a Person entry.');
      return;
    }
  }

  // Ensure each form captures the entryState (kept as-is)
  if (tab === 'Person') noteData.addressState = modalEntryState;
  if (tab === 'Vehicle') noteData.addressState = modalEntryState;
  if (tab === 'Place')   noteData.addressState = modalEntryState;

  const fullNote = {
    ...noteData,
    type: tab,
    timestamp: new Date(),
    ownerId: userId,
    ownerName: ownerName,
    rank: userRank,
    agency: userAgency,
    flags: formFlags,
    entryState: modalEntryState || userState,
  };

  try {
    // 📸 Upload attached photos
setIsCreatingNote(true);
let uploadedUrls = [];
if (selectedFiles.length > 0) {
  try {
    const uploads = await Promise.all(
      selectedFiles.map(async (file) => {
        const fileRef = ref(storage, `sharedNotes/${userId}/${Date.now()}_${file.name}`);
        const snapshot = await uploadBytes(fileRef, file);
        return await getDownloadURL(snapshot.ref);
      })
    );
    uploadedUrls = uploads;
  } catch (err) {
    console.error("Error uploading photos:", err);
  }
}

// ✅ Include photos in note
fullNote.photoUrls = uploadedUrls;

    console.log("Saving note:", fullNote);
   const docRef = await addDoc(
  collection(firestore, "sharedNotes"),
  sanitizeNoteForFirestore(fullNote)
);
    const savedNote = { ...fullNote, id: docRef.id };

    if (typeof fetchNotes === "function") {
      fetchNotes();
    } else {
      console.warn("fetchNotes is not defined.");
    }

    // Clear only the active tab form (kept as-is)
    if (tab === 'Person') {
      setPersonForm({ gangAffiliated: false, gangName: '' });
    }
    if (tab === 'Vehicle') setVehicleForm({});
    if (tab === 'Place')   setPlaceForm({});

    setFormFlags([]);
    setSelectedFiles([]);
    setPreviewUrls([]);
    setModalVisible(false);
    setCustomFlag({ code: '', description: '' });
  } catch (error) {
    console.error("Error adding note:", error);
  } finally {
    setIsCreatingNote(false);
  }
};



  const formatDOB = (value) => {
  const digits = value.replace(/\D/g, ''); // remove non-digits
  const mm = digits.slice(0, 2);
  const dd = digits.slice(2, 4);
  const yyyy = digits.slice(4, 8);

  let formatted = mm;
  if (dd) formatted += '/' + dd;
  if (yyyy) formatted += '/' + yyyy;

  return formatted;
};




  const handleWebShareNote = async (note) => {
  let content = `Note Type: ${note.type}\n`;

  if (note.type === 'Person') {
    content += `Name: ${note.firstName || ''} ${note.middleName || ''} ${note.lastName || ''}\n`;
    content += `DOB: ${note.dob} (Age: ${note.age || ''})\n`;
    content += `Race/Sex: ${note.race}/${note.sex}\n`;
    content += `Address: ${note.address}, ${note.addressState}\n`;
    content += `DL: ${note.dl} (${note.dlState})\n`;
    content += `Phone: ${note.phone}\n`;
    content += `Narrative: ${note.narrative || ''}\n`;
  } else if (note.type === 'Vehicle') {
    content += `Make/Model: ${note.make} ${note.model}\n`;
    content += `Plate/State: ${note.plate} / ${note.plateState}\n`;
    content += `Color: ${note.color}\n`;
    content += `Owner: ${note.owner}\n`;
    content += `Narrative: ${note.narrative || ''}\n`;
  } else if (note.type === 'Place') {
    content += `Address: ${note.address}\n`;
    content += `Owner: ${note.owner}\n`;
    content += `Occupants: ${(note.occupants || []).join(', ')}\n`;
    content += `Narrative: ${note.narrative || ''}\n`;
  }

  if (navigator.share) {
    try {
      await navigator.share({
        title: 'Shared Note',
        text: content
      });
    } catch (err) {
      console.error('Sharing failed:', err);
    }
  } else {
    try {
      await navigator.clipboard.writeText(content);
      alert('Note copied to clipboard!');
    } catch (err) {
      console.error('Clipboard write failed:', err);
      alert('Unable to copy the note.');
    }
  }
};



    const handleTabChange = (newTab) => {
  setTab(newTab);

  if (newTab === 'Person') {
    setVehicleForm({
      make: '',
      model: '',
      plate: '',
      plateState: '',
      color: '',
      owner: '',
      narrative: ''
    });
    setPlaceForm({
      address: '',
      owner: '',
      occupants: [],
      narrative: ''
    });
  } else if (newTab === 'Vehicle') {
    setPersonForm({
      firstName: '',
      middleName: '',
      lastName: '',
      dob: '',
      age: '',
      race: '',
      sex: '',
      address: '',
      addressState: '',
      dl: '',
      dlState: '',
      phone: '',
      narrative: ''
    });
    setPlaceForm({
      address: '',
      owner: '',
      occupants: [],
      narrative: ''
    });
  } else if (newTab === 'Place') {
    setPersonForm({
      firstName: '',
      middleName: '',
      lastName: '',
      dob: '',
      age: '',
      race: '',
      sex: '',
      address: '',
      addressState: '',
      dl: '',
      dlState: '',
      phone: '',
      narrative: ''
    });
    setVehicleForm({
      make: '',
      model: '',
      plate: '',
      plateState: '',
      color: '',
      owner: '',
      narrative: ''
    });
  }
};



   const handleEditNote = (note) => {
  setEditModeId(note.id);
  setEditedNoteData({ ...note });
  setEditedNoteFlags(note.flags || []);
};


  const handleSubmitComment = async (note) => {
  if (commentSubmittingNoteId) return;
  if (!newCommentText.trim()) {
    alert("Please write something in the comment.");
    return;
  }

  const comment = {
    text: newCommentText.trim(),
    timestamp: new Date(),
    ownerId: userId,
    ownerName,
    rank: userRank,
    agency: userAgency,
    flags: newCommentFlags
  };

  try {
    setCommentSubmittingNoteId(note.id);
    await addDoc(
  collection(db, "sharedNotes", note.id, "comments"),
  sanitizeNoteForFirestore(comment)
);
    console.log("Comment submitted!");

    const missingFlags = newCommentFlags.filter(flag => !(note.flags || []).includes(flag));
    if (missingFlags.length > 0) {
     await updateDoc(
  doc(db, "sharedNotes", note.id),
  sanitizeNoteForFirestore({
    flags: arrayUnion(...missingFlags),
  })
);
    }

    // Clear form
    setNewCommentText("");
    setNewCommentFlags([]);

    // ✅ Refresh comments for this note
    fetchComments(note.id);

    // ✅ Close the comment form
    setVisibleCommentNoteId(null);

    // 🔄 Update count locally
    setCommentCounts(prev => ({
  ...prev,
  [note.id]: (prev[note.id] || 0) + 1
}));


  } catch (err) {
    console.error("Error submitting comment:", err);
    alert("Failed to submit comment.");
  } finally {
    setCommentSubmittingNoteId("");
  }
};



const handleSaveInlineEdit = async () => {
  if (isSavingNote) return;
  try {
    setIsSavingNote(true);
    const {
      id,
      fullName,
      firstNameLower,
      lastNameLower,
      lastNameDob,
      plateWithState,
      plateStateCombo,
      ...data
    } = editedNoteData;

    // ✅ Prepare Firestore ref
    const noteRef = doc(firestore, "sharedNotes", id);

    // ✅ Upload any new attachments first (if present)
    if (editedFiles.length > 0) {
      try {
        const uploaded = await Promise.all(
          editedFiles.map(async (file) => {
            const fileRef = ref(storage, `sharedNotes/${userId}/${Date.now()}_${file.name}`);
            const snapshot = await uploadBytes(fileRef, file);
            const url = await getDownloadURL(snapshot.ref);
            return url;
          })
        );
        data.photoUrls = [...(data.photoUrls || []), ...uploaded];
      } catch (err) {
        console.error("⚠️ Error uploading new attachments:", err);
      }
    }

    // ✅ Save to Firestore
   await updateDoc(
  noteRef,
  sanitizeNoteForFirestore({
    ...data,
    flags: editedNoteFlags,
    editedAt: new Date(),
  })
);

    // ✅ Update local search results immediately
    setSearchResults((prev) =>
      prev.map((note) =>
        note.id === id
          ? { ...note, ...data, flags: editedNoteFlags, editedAt: new Date() }
          : note
      )
    );

    // ✅ Also update local notes list + cache for real-time reflection
    setNotes((prevNotes) => {
      const updated = prevNotes.map((n) =>
        n.id === id
          ? { ...n, ...data, flags: editedNoteFlags, editedAt: new Date() }
          : n
      );
      localStorage.setItem(`cachedNotes_${userId}`, JSON.stringify(updated));
      setFilteredNotes(updated);
      return updated;
    });

    // ✅ Reset editing state
    setEditModeId(null);
    setEditedNoteData({});
    setEditedFiles([]);
    setEditedPreviewUrls([]);

    toast.success("✅ Note updated successfully!");
  } catch (err) {
    console.error("❌ Error updating note:", err);
    alert("Failed to update note.");
  } finally {
    setIsSavingNote(false);
  }
};




	const handleEditComment = (noteId, index) => {
  const comment = noteComments[noteId][index];
  setEditingComment({ noteId, index, commentId: comment.id });
  setEditedCommentText(comment.text);
  setEditedCommentFlags(comment.flags || []);
};
	const fetchComments = (noteId) => {
  try {
    const q = query(
      collection(db, "sharedNotes", noteId, "comments"),
      orderBy("timestamp", "desc")
    );

    // Set up a listener for this note's comments
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const comments = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setNoteComments(prev => ({ ...prev, [noteId]: comments }));
    });

    // Return unsubscribe so you can clean it up later if needed
    commentUnsubscribers.current[noteId] = unsubscribe;
  } catch (error) {
    console.error("Failed to set up comments listener:", error);
  }
};



const handleSaveEditedComment = async () => {
  if (isSavingComment) return;
  const { noteId, commentId } = editingComment;

  if (!editedCommentText.trim()) {
    alert("Comment cannot be blank.");
    return;
  }

  try {
    setIsSavingComment(true);
    const commentRef = doc(db, "sharedNotes", noteId, "comments", commentId);
   await updateDoc(
  commentRef,
  sanitizeNoteForFirestore({
    text: editedCommentText,
    flags: editedCommentFlags,
    editedAt: new Date(),
  })
);


    // ✅ Update local state immediately
    setNoteComments(prev => {
      const updated = prev[noteId].map(c =>
        c.id === commentId
          ? { ...c, text: editedCommentText, editedAt: new Date() }
          : c
      );
      return { ...prev, [noteId]: updated };
    });

    setEditingComment(null);
    setEditedCommentText("");

    // ✅ One-time refresh of latest comments (optional but accurate)
    fetchComments(noteId);

  } catch (err) {
    console.error("Error updating comment:", err);
    alert("Failed to update comment.");
  } finally {
    setIsSavingComment(false);
  }
};



const handleDeleteComment = async (noteId, commentId) => {
  if (deletingCommentId) return;
  const confirmed = window.confirm("Are you sure you want to delete this comment?");
  if (!confirmed) return;

  try {
    setDeletingCommentId(commentId);
    await deleteDoc(doc(db, "sharedNotes", noteId, "comments", commentId));

    // Optionally remove it from local state
setNoteComments(prev => {
  const filtered = prev[noteId].filter(c => c.id !== commentId);
  return { ...prev, [noteId]: filtered };
});

// 🔄 Update count locally
setCommentCounts(prev => ({
  ...prev,
  [noteId]: Math.max((prev[noteId] || 1) - 1, 0)
}));

// ✅ Refresh the notes to show updates
fetchNotes();

  } catch (err) {
    console.error("Error deleting comment:", err);
    alert("Failed to delete comment.");
  } finally {
    setDeletingCommentId("");
  }
};


 	

const handleDeleteNote = async (id) => {
  if (deletingNoteId) return;
  if (!window.confirm("Are you sure you want to delete this note and all attached photos?")) return;

  try {
    setDeletingNoteId(id);
    const noteRef = doc(firestore, "sharedNotes", id);

    // Delete the Firestore document; Cloud Functions clean up attachments.
    await deleteDoc(noteRef);
    console.log("🗑️ Note deleted from Firestore:", id);

    // ✅ Immediately remove from all UI state and cache
    setNotes((prev) => {
      const updated = prev.filter((n) => n.id !== id);
      setFilteredNotes(updated);
      setSearchResults((prevResults) =>
        prevResults.filter((r) => r.id !== id)
      );

      // ✅ Rewrite cache
      localStorage.setItem(`cachedNotes_${userId}`, JSON.stringify(updated));

      return updated;
    });

    // ✅ Extra safeguard — remove any lingering cache entries
    try {
      const cached = localStorage.getItem(`cachedNotes_${userId}`);
      if (cached) {
        const parsed = JSON.parse(cached).filter((n) => n.id !== id);
        localStorage.setItem(`cachedNotes_${userId}`, JSON.stringify(parsed));
      }
    } catch (err) {
      console.warn("⚠️ Could not clean cached notes:", err);
    }

    toast.success("🗑️ Note and attachments deleted successfully!");
  } catch (err) {
    console.error("❌ Error deleting note:", err);
    alert("Failed to delete note.");
  } finally {
    setDeletingNoteId("");
  }
};



 const renderTabFields = () => {
  if (tab === 'Person') {
    return (
      <>
        <div className="modal-entry-state-row">
          <span className="modal-entry-state-label">Entry State:</span>
          {renderModalStateDropdown()}
        </div>

        <input
          type="text"
          placeholder="First Name"
          value={personForm.firstName || ''}
          onChange={e => setPersonForm(f => ({ ...f, firstName: e.target.value }))}
        />

<input
  type="text"
  placeholder="Middle Name"
  value={personForm.middleName || ''}
  onChange={e => setPersonForm(f => ({ ...f, middleName: e.target.value }))}
/>

<input
  type="text"
  placeholder="Last Name"
  value={personForm.lastName || ''}
  onChange={e => setPersonForm(f => ({ ...f, lastName: e.target.value }))}
/>

<input
  type="text"
  placeholder="DOB (MM/DD/YYYY)"
  maxLength={10}
  value={personForm.dob || ''}
  onChange={e => {
    const formattedDOB = formatDOB(e.target.value);
    const age = calculateAge(formattedDOB);
    setPersonForm(f => ({ ...f, dob: formattedDOB, age }));
  }}
/>


<input
  type="text"
  placeholder="Race (e.g. B, W, A, U)"
  value={personForm.race || ''}
  onChange={e => setPersonForm(f => ({ ...f, race: e.target.value }))}
/>

<input
  type="text"
  placeholder="Sex (e.g. M, F)"
  value={personForm.sex || ''}
  onChange={e => setPersonForm(f => ({ ...f, sex: e.target.value }))}
/>

<input
  type="text"
  placeholder="Street Address"
  value={personForm.streetAddress || ''}
  onChange={e => setPersonForm(f => ({ ...f, streetAddress: e.target.value }))}
/>

<input
  type="text"
  placeholder="City"
  value={personForm.city || ''}
  onChange={e => setPersonForm(f => ({ ...f, city: e.target.value }))}
/>

<input
  type="text"
  placeholder="State"
  value={personForm.addressState || ''}
  onChange={e => setPersonForm(f => ({ ...f, addressState: e.target.value }))}
/>


<input
  type="text"
  placeholder="DL #"
  value={personForm.dl || ''}
  onChange={e => setPersonForm(f => ({ ...f, dl: e.target.value }))}
/>

<input
  type="text"
  placeholder="DL State"
  value={personForm.dlState || ''}
  onChange={e => setPersonForm(f => ({ ...f, dlState: e.target.value }))}
/>

<input
  type="text"
  placeholder="Phone"
  value={personForm.phone || ''}
  onChange={e => setPersonForm(f => ({ ...f, phone: e.target.value }))}
/>

 {/* Gang Affiliation Toggle for NEW ENTRIES */}
<div style={{ marginTop: '12px', marginBottom: '10px' }}>
  <label>
    Gang Affiliation:
    <select
      value={personForm.gangAffiliated ? 'Yes' : 'No'}
      onChange={e => {
        const isAffiliated = e.target.value === 'Yes';
        setPersonForm(f => ({
          ...f,
          gangAffiliated: isAffiliated,
          gangName: isAffiliated ? f.gangName : '' // Clear name if 'No'
        }));
      }}
      style={{ marginLeft: '8px' }}
    >
      <option value="No">No</option>
      <option value="Yes">Yes</option>
    </select>
  </label>
  {personForm.gangAffiliated && (
    <>
      <span style={{ color: 'red', marginLeft: '10px' }}>GNG</span>
      <input
        placeholder="Short Gang Name"
        value={personForm.gangName || ''}
        onChange={e =>
          setPersonForm(f => ({ ...f, gangName: e.target.value }))
        }
        style={{ marginLeft: '10px' }}
      />
    </>
  )}
</div>


{(personForm.knownAssociates || []).map((assoc, index) => (
  <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
    <input
      type="text"
      placeholder={`Associate #${index + 1}`}
      value={assoc || ''}
      onChange={(e) => {
        const updated = [...personForm.knownAssociates];
        updated[index] = e.target.value;
        setPersonForm((f) => ({ ...f, knownAssociates: updated }));
      }}
      style={{ flex: 1 }}
    />
    <button
      type="button"
      onClick={() => {
        const updated = [...personForm.knownAssociates];
        updated.splice(index, 1);
        setPersonForm((f) => ({ ...f, knownAssociates: updated }));
      }}
      style={{
        marginLeft: '8px',
        backgroundColor: '#e3342f',
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '4px',
        cursor: 'pointer',
      }}
    >
      ❌
    </button>
  </div>
))}

<button
  type="button"
  onClick={() =>
    setPersonForm((f) => ({
      ...f,
      knownAssociates: [...(f.knownAssociates || []), '']
    }))
  }
  style={{
    marginBottom: '10px',
    backgroundColor: '#1e3a8a',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
  }}
>
  + Add Known Associate
</button>



          <textarea className="note-textarea full-width" placeholder="Narrative" rows="5" onChange={e => setPersonForm(f => ({ ...f, narrative: e.target.value }))}></textarea>
        </>
      );
    } else if (tab === 'Vehicle') {
      return (
        <>
  <div className="modal-entry-state-row">
    <span className="modal-entry-state-label">Entry State:</span>
    {renderModalStateDropdown()}
  </div>
          <input
  className="note-input"
  type="text"
  placeholder="Make"
  value={vehicleForm.make || ''}
  onChange={e => setVehicleForm(f => ({ ...f, make: e.target.value }))}
/>

<input
  className="note-input"
  type="text"
  placeholder="Model"
  value={vehicleForm.model || ''}
  onChange={e => setVehicleForm(f => ({ ...f, model: e.target.value }))}
/>

<input
  className="note-input"
  type="text"
  placeholder="Plate"
  value={vehicleForm.plate || ''}
  onChange={e => setVehicleForm(f => ({ ...f, plate: e.target.value }))}
/>

<input
  className="note-input"
  type="text"
  placeholder="State"
  value={vehicleForm.plateState || ''}
  onChange={e => setVehicleForm(f => ({ ...f, plateState: e.target.value }))}
/>

<input
  className="note-input"
  type="text"
  placeholder="Color"
  value={vehicleForm.color || ''}
  onChange={e => setVehicleForm(f => ({ ...f, color: e.target.value }))}
/>

<input
  className="note-input"
  type="text"
  placeholder="Owner"
  value={vehicleForm.owner || ''}
  onChange={e => setVehicleForm(f => ({ ...f, owner: e.target.value }))}
/>

          <textarea className="note-textarea full-width" placeholder="Narrative" rows="5" onChange={e => setVehicleForm(f => ({ ...f, narrative: e.target.value }))}></textarea>
        </>
      );
    } else {
			// PLACE
      return (
       <>
  <div className="modal-entry-state-row">
    <span className="modal-entry-state-label">Entry State:</span>
    {renderModalStateDropdown()}
  </div>
      <input
  className="note-input"
  type="text"
  placeholder="Street Address"
  value={placeForm.streetAddress || ''}
  onChange={e => setPlaceForm(f => ({ ...f, streetAddress: e.target.value }))}
/>
<input
  className="note-input"
  type="text"
  placeholder="City"
  value={placeForm.city || ''}
  onChange={e => setPlaceForm(f => ({ ...f, city: e.target.value }))}
/>
<input
  className="note-input"
  type="text"
  placeholder="State"
  value={placeForm.addressState || ''}
  onChange={e => setPlaceForm(f => ({ ...f, addressState: e.target.value }))}
/>
<input
  className="note-input"
  type="text"
  placeholder="Zip"
  value={placeForm.addressZip || ''}
  onChange={e => setPlaceForm(f => ({ ...f, addressZip: e.target.value }))}
/>


<input
  className="note-input"
  type="text"
  placeholder="Owner"
  value={placeForm.owner || ''}
  onChange={e => setPlaceForm(f => ({ ...f, owner: e.target.value }))}
/>


{placeForm.occupants?.map((occ, index) => (
  <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '8px' }}>
    <input
      type="text"
      className="note-input"
      placeholder={`Occupant #${index + 1}`}
      value={occ || ''}
      onChange={(e) => {
        const updated = [...placeForm.occupants];
        updated[index] = e.target.value;
        setPlaceForm((f) => ({ ...f, occupants: updated }));
      }}
      style={{ flex: 1 }}
    />
    <button
      type="button"
      onClick={() => {
        const updated = [...placeForm.occupants];
        updated.splice(index, 1);
        setPlaceForm((f) => ({ ...f, occupants: updated }));
      }}
      style={{
        marginLeft: '8px',
        backgroundColor: '#e3342f',
        color: 'white',
        border: 'none',
        padding: '4px 8px',
        borderRadius: '4px',
        cursor: 'pointer',
      }}
    >
      ❌
    </button>
  </div>
))}

<button
  type="button"
  onClick={() =>
    setPlaceForm((f) => ({
      ...f,
      occupants: [...(f.occupants || []), '']
    }))
  }
  style={{
    marginTop: '8px',
    backgroundColor: '#1e3a8a',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    borderRadius: '6px',
    cursor: 'pointer',
  }}
>
  + Add Occupant
</button>

          <textarea className="note-textarea full-width" placeholder="Narrative" rows="5" onChange={e => setPlaceForm(f => ({ ...f, narrative: e.target.value }))}></textarea>
        </>
      );
    }
  };





return (
  <>
    <div className="database-page">
      <div className="header-row">
        <h1 className="page-title">Database Search</h1>
        {!modalVisible && (
          <button className="add-note-btn" onClick={() => setModalVisible(true)}>
            New Entry
          </button>
        )}
      </div>

	<div style={{ margin: '8px 20px', fontSize: '0.9rem', color: '#555', fontStyle: 'italic' }}>
  <div>
    • This database allows officers to share and access important information about individuals,
    vehicles, and locations that may pose risks or warrant caution. Search by name, address,
    phone number, or keywords to review notes by other officers. Results include exact and close
    matches, with exact matches highlighted.
  </div>
  <div style={{ marginTop: '4px' }}>
    • If you encounter suspicious, uncooperative, aggressive, or otherwise concerning behavior,
    consider adding a new entry so fellow officers can make informed decisions in future interactions.
  </div>

  {/* ⚠️ Warning section */}
 <div
  className="database-warning"
  style={{
    marginTop: '10px',
    backgroundColor: '#fff8e1',
    border: '2px solid #d32f2f',
    borderRadius: '8px',
    padding: '12px 16px',
    color: '#333',
    lineHeight: '1.6',
  }}
>
  <div style={{ fontWeight: 'bold', color: '#d32f2f', fontSize: '1rem' }}>
    ⚠️ Important!
  </div>

  <div style={{ marginTop: '6px' }}>
    Information shared in this Database is officer-generated and intended
    <strong> only for safety awareness and collaboration.</strong>
  </div>

  <div
    style={{
      marginTop: '8px',
      color: '#d32f2f',
      fontWeight: 'bold',
      textDecoration: 'underline',
    }}
  >
    Do <strong>not</strong> enter data obtained from <strong>CJIS-regulated systems</strong> such as
    <strong> NCIC, NLETS, CJLEADS, DMV, or agency RMS</strong>.
  </div>

  <div style={{ marginTop: '8px' }}>
    This platform is <strong>not an official law enforcement record</strong> and
    <strong> must not be used as the basis for enforcement action.</strong>
  </div>
</div>

</div>



	

{/* 🔎 Firestore Search trough algolia */}
<div className="search-controls">
<label className="entry-state-label">
  <span className="search-state-text">Search State:</span>
  {renderStateDropdown()}
</label>


  <input
    type="text"
    placeholder="Search all fields..."
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    className="search-bar"
  />

  <button onClick={handleAlgoliaSearch} className="search-button">
    Search
  </button>
</div>

 	{hasSearched && searchResults.length === 0 && (
  <div style={{ marginTop: '16px', textAlign: 'center', color: '#666' }}>
    No matches found.
  </div>
)}

		 {/* ** Result -displaying Logic  ***/}
	{searchResults.length > 0 && (
      <div className={`notes-list ${!sidebarVisible ? 'compact' : ''}`}>
        {searchResults.map(note => (
          <div
            key={note.id}
            className={`note-preview ${note.flagged ? 'flagged-note' : ''}`}
            onClick={(e) => {
              if (editModeId === note.id) return;
              setExpandedNoteId((prev) => (prev === note.id ? null : note.id));
            }}
          >

	   	{note.flags?.length > 0 && (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', justifyContent: 'flex-end', marginBottom: '4px' }}>
                     {note.flags
  .filter(flag => flag && flag.code && flag.description) // Skip empty or invalid flags
  .map((flag, idx) => {
    const key = note.id + '-' + idx;
    const isVisible = visibleFlagDescriptions[key];
    return (
      <div key={idx} ref={(el) => (flagRefs.current[key] = el)} style={{ position: 'relative' }}>
        <span
          onClick={(e) => {
            e.stopPropagation();
            setVisibleFlagDescriptions(prev => ({ ...prev, [key]: !prev[key] }));
          }}
          style={{
            backgroundColor: 'red',
            color: 'white',
            padding: '2px 6px',
            borderRadius: '4px',
            fontSize: '12px',
            fontWeight: 'bold',
            cursor: 'pointer'
          }}
        >
          {flag.code}
        </span>
        {isVisible && (
          <div
            style={{
              position: 'absolute',
              top: '120%',
              right: 0,
              backgroundColor: '#fff3f3',
              color: '#a00',
              padding: '6px 10px',
              border: '1px solid red',
              borderRadius: '4px',
              fontSize: '12px',
              maxWidth: '200px',
              zIndex: 50
            }}
          >
            {flag.description}
          </div>
        )}
      </div>
    );
  })}
   </div>
  )}


            {note.type === 'Person' && (
  <div style={{ fontWeight: 'bold' }}>
 {expandedNoteId !== note.id && (
    <span style={{ marginLeft: '8px', fontSize: '14px', color: '#555' }}>▼</span>
  )}
   {highlightWithFuzzy(note.firstName || '', note, 'firstName')} {highlightWithFuzzy(note.lastName || '', note, 'lastName')}, DOB: {highlightWithFuzzy(note.dob || '', note, 'dob')}

  </div>
)}

            {note.type === 'Vehicle' && (
  <div style={{ fontWeight: 'bold' }}>
    {expandedNoteId !== note.id && (
      <span style={{ marginRight: '8px', fontSize: '14px', color: '#555' }}>▼</span>
    )}
    {highlightWithFuzzy(note.make || '', note, 'make')}{' '}
    {highlightWithFuzzy(note.model || '', note, 'model')}, {' '}
    {highlightWithFuzzy(note.plate || '', note, 'plate')}, {' '}
    {highlightWithFuzzy(note.color || '', note, 'color')}
  </div>
)}


        {note.type === 'Place' && (
  <div style={{ fontWeight: 'bold' }}>
    {expandedNoteId !== note.id && (
      <span style={{ marginRight: '8px', fontSize: '14px', color: '#555' }}>▼</span>
    )}
    {highlightWithFuzzy(note.streetAddress || '', note, 'streetAddress')}
    {note.city && ', '}
    {highlightWithFuzzy(note.city || '', note, 'city')}
    {note.addressState && ', '}
    {highlightWithFuzzy(note.addressState || '', note, 'addressState')}
    {note.addressZip && ', '}
    {highlightWithFuzzy(note.addressZip || '', note, 'addressZip')}
    {note.owner && ', Owner: '}
    {highlightWithFuzzy(note.owner || '', note, 'owner')}
  </div>
)}

            {expandedNoteId === note.id && (
              <div className="note-details">
                <div className="note-clean-display">
                   {/* PERSON */}
          {note.type === 'Person' && (
            <>
              <div><strong>Full Name:</strong> {editModeId === note.id ? (
                <>
                  <input value={editedNoteData.firstName || ''} onChange={e => setEditedNoteData(f => ({ ...f, firstName: e.target.value }))} placeholder="First Name" />
                  <input value={editedNoteData.middleName || ''} onChange={e => setEditedNoteData(f => ({ ...f, middleName: e.target.value }))} placeholder="Middle Name" />
                  <input value={editedNoteData.lastName || ''} onChange={e => setEditedNoteData(f => ({ ...f, lastName: e.target.value }))} placeholder="Last Name" />
                </>
              ) : `${note.firstName} ${note.middleName} ${note.lastName}`}</div>

              <div><strong>DOB:</strong> {editModeId === note.id ? (
                <input value={editedNoteData.dob || ''} onChange={e => {
                  const dob = e.target.value;
                  const age = calculateAge(dob);
                  setEditedNoteData(f => ({ ...f, dob, age }));
                }} />
              ) : `${note.dob} (Age: ${note.age})`}</div>

              <div><strong>Race/Sex:</strong> {editModeId === note.id ? (
  <>
    <input
      value={editedNoteData.race || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, race: e.target.value }))}
      placeholder="Race"
    />
    <input
      value={editedNoteData.sex || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, sex: e.target.value }))}
      placeholder="Sex"
    />

    
    <div style={{ marginTop: '8px' }}>
      <strong>Flags:</strong>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>
        {editedNoteFlags.map((flag, idx) => {
          const code = typeof flag === 'string' ? flag : flag.code;
          const desc = typeof flag === 'string'
            ? allFlagOptions.find((f) => f.code === flag)?.description || flag
            : flag.description;

          return (
            <span
              key={idx}
              style={{
                backgroundColor: '#f8d7da',
                color: '#721c24',
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: 'bold',
                position: 'relative'
              }}
            >
              {code}
              <button
                onClick={() => {
                  setEditedNoteFlags(f => f.filter((_, i) => i !== idx));
                }}
                style={{
                  marginLeft: '6px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  fontWeight: 'bold'
                }}
              >
                ❌
              </button>
            </span>
          );
        })}
      </div>
    </div>
    {/* End flags block */}
  </>
) : `${note.race}/${note.sex}`}</div>

                

              <div><strong>Address:</strong> {editModeId === note.id ? (
  <>
    <input
      value={editedNoteData.streetAddress || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, streetAddress: e.target.value }))}
      placeholder="Street Address"
    />
    <input
      value={editedNoteData.city || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, city: e.target.value }))}
      placeholder="City"
    />
    <input
      value={editedNoteData.addressState || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, addressState: e.target.value }))}
      placeholder="State"
    />
  </>
) : (
  <>
   {highlightWithFuzzy(note.streetAddress || '', note, 'streetAddress')}, 
{highlightWithFuzzy(note.city || '', note, 'city')}, 
{highlightWithFuzzy(note.addressState || '', note, 'addressState')}
  </>
)}</div>



              <div><strong>DL #:</strong> {editModeId === note.id ? (
  <>
    <input
      value={editedNoteData.dl || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, dl: e.target.value }))}
      placeholder="DL #"
    />
    <input
      value={editedNoteData.dlState || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, dlState: e.target.value }))}
      placeholder="DL State"
    />
  </>
) : (
  <>
    {highlightWithFuzzy(note.dl || '', note, 'dl')} 
({highlightWithFuzzy(note.dlState || '', note, 'dlState')})
  </>
)}</div>


             <div><strong>Phone:</strong> {editModeId === note.id ? (
  <input value={editedNoteData.phone || ''} onChange={e => setEditedNoteData(f => ({ ...f, phone: e.target.value }))} placeholder="Phone" />
) : highlightWithFuzzy(note.phone || '', note, 'phone')}</div>


		{editModeId === note.id ? (
  <div style={{ marginTop: '12px', marginBottom: '10px' }}>
    <label>
      Gang Affiliation:
      <select
        value={editedNoteData.gangAffiliated || 'No'}
        onChange={e =>
          setEditedNoteData(f => ({
            ...f,
            gangAffiliated: e.target.value
          }))
        }
        style={{ marginLeft: '8px' }}
      >
        <option value="No">No</option>
        <option value="Yes">Yes</option>
      </select>
    </label>
    {editedNoteData.gangAffiliated === 'Yes' && (
      <>
        <span style={{ color: 'red', marginLeft: '10px' }}>GNG</span>
        <input
          placeholder="Short Gang Name"
          value={editedNoteData.gangName || ''}
          onChange={e =>
            setEditedNoteData(f => ({ ...f, gangName: e.target.value }))
          }
          style={{ marginLeft: '10px' }}
        />
      </>
    )}
  </div>
) : (
  (note.gangAffiliated === true || note.gangAffiliated === 'Yes') &&
  note.gangName?.trim() && (
    <div style={{ color: 'red' }}>
      <strong>GNG:</strong> {note.gangName}
    </div>
  )
)}

	    <div><strong>Known Associates:</strong> {editModeId === note.id ? (
  <>
    {(editedNoteData.knownAssociates || []).map((assoc, index) => (
      <input
        key={index}
        value={assoc}
        placeholder={`Associate #${index + 1}`}
        onChange={(e) => {
          const updated = [...editedNoteData.knownAssociates];
          updated[index] = e.target.value;
          setEditedNoteData(f => ({ ...f, knownAssociates: updated }));
        }}
        style={{ display: 'block', marginBottom: '6px' }}
      />
    ))}
    <button onClick={() =>
      setEditedNoteData(f => ({
        ...f,
        knownAssociates: [...(f.knownAssociates || []), '']
      }))
    }>+ Add Associate</button>
  </>
) : (
  (note.knownAssociates || []).map((assoc, i) => (
    <div key={i}>{highlightWithFuzzy(assoc || '', note, 'knownAssociates')}</div>
  ))
)}</div>

            <div><strong>Narrative:</strong> {editModeId === note.id ? (
   		<textarea
                  className="wide-textarea"
                  name="narrative"
                  value={editedNoteData.narrative || ''}
                  onChange={e => setEditedNoteData(f => ({ ...f, narrative: e.target.value }))} />
) : highlightWithFuzzy(note.narrative || "", note, 'narrative')}
</div>

	{/* 📸 Attached Photos */}
{Array.isArray(note.photoUrls) && note.photoUrls.length > 0 && (
  <div style={{ marginTop: "10px" }}>
    <strong>Attached Photos:</strong>
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "6px" }}>
      {note.photoUrls.map((url, i) => (
        <div
          key={i}
          style={{
            width: "120px",
            height: "120px",
            overflow: "visible",
            borderRadius: "6px",
            border: "1px solid #ccc",
            cursor: "pointer",
            position: "relative",
          }}
        onClick={(e) => {
 	 e.stopPropagation();
	  setModalImage(url);
	}}
        >
          <img
            src={url}
            alt={`Attachment ${i + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
          {editModeId === note.id && (
  <button
    type="button"
    onClick={(e) => {
  e.stopPropagation();

  setEditedNoteData((prev) => {
    const updatedPhotos = prev.photoUrls.filter((_, idx) => idx !== i);
    const updated = { ...prev, photoUrls: updatedPhotos };

    setNotes((prevNotes) =>
      prevNotes.map((n) =>
        n.id === prev.id ? { ...n, photoUrls: updatedPhotos } : n
      )
    );

    setFilteredNotes((prevFiltered) =>
      prevFiltered.map((n) =>
        n.id === prev.id ? { ...n, photoUrls: updatedPhotos } : n
      )
    );

    setSearchResults((prevResults) =>
      prevResults.map((r) =>
        r.id === prev.id ? { ...r, photoUrls: updatedPhotos } : r
      )
    );

    return updated;
  });
}}
    style={{
      position: "absolute",
      top: "-10px",
      right: "-10px",
      background: "rgba(0,0,0,0.6)",
      color: "white",
      border: "none",
      borderRadius: "50%",
      width: "22px",
      height: "22px",
      cursor: "pointer",
      fontWeight: "bold",
      zIndex: 5,
      opacity: 0.8,
      transition: "opacity 0.2s, transform 0.2s",
    }}
    onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
    onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.8")}
    title="Remove photo"
  >
    ×
  </button>
)}

        </div>
      ))}
    </div>
  </div>
)}

	{/* 📎 Add New Attachments (Edit Mode Only, if owner) */}
{editModeId === note.id && note.ownerId === userId && (
  <div style={{ marginTop: "12px" }}>
    <label style={{ fontWeight: "bold" }}>Add Attachments:</label>
    <input
      type="file"
      accept="image/*,.pdf,.doc,.docx,.txt"
      multiple
      style={{
        display: "block",
        marginTop: "6px",
      }}
      onChange={(e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
          const previews = files.map((f) => URL.createObjectURL(f));
          setEditedFiles((prev) => [...(prev || []), ...files]);
          setEditedPreviewUrls((prev) => [...(prev || []), ...previews]);
        }
      }}
    />

    {/* Show new previews */}
    {editedPreviewUrls.length > 0 && (
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          marginTop: "10px",
        }}
      >
        {editedPreviewUrls.map((src, i) => (
          <div key={i} style={{ position: "relative" }}>
            <img
              src={src}
              alt={`New ${i + 1}`}
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            />
            <button
              type="button"
              onClick={() => {
                setEditedFiles((prev) =>
                  prev.filter((_, idx) => idx !== i)
                );
                setEditedPreviewUrls((prev) =>
                  prev.filter((_, idx) => idx !== i)
                );
              }}
              style={{
                position: "absolute",
                top: "-6px",
                right: "-6px",
                background: "rgba(0,0,0,0.6)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "20px",
                height: "20px",
                cursor: "pointer",
                fontWeight: "bold",
              }}
            >
              ×
            </button>
          </div>
        ))}
      </div>
    )}
  </div>
)}

        
  </>
    )}


          {/* VEHICLE */}
          {note.type === 'Vehicle' && (
            <>
              <div><strong>Make/Model:</strong> {editModeId === note.id ? (
  <>
    <input
      value={editedNoteData.make || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, make: e.target.value }))}
      placeholder="Make"
    />
    <input
      value={editedNoteData.model || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, model: e.target.value }))}
      placeholder="Model"
    />
  </>
) : (
  <span>
    {highlightWithFuzzy(note.make || '', note, 'make')}{' '}
    {highlightWithFuzzy(note.model || '', note, 'model')}
  </span>
)}</div>



              <div><strong>Plate/State:</strong> {editModeId === note.id ? (
  <>
    <input
      value={editedNoteData.plate || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, plate: e.target.value }))}
      placeholder="Plate"
    />
    <input
      value={editedNoteData.plateState || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, plateState: e.target.value }))}
      placeholder="State"
    />
  </>
) : (
  <>
    {highlightWithFuzzy(note.plate || '', note, 'plate')} / {highlightWithFuzzy(note.plateState || '', note, 'plateState')}
  </>
)}</div>


              <div><strong>Color:</strong> {editModeId === note.id ? (
                <input value={editedNoteData.color || ''} onChange={e => setEditedNoteData(f => ({ ...f, color: e.target.value }))} placeholder="Color" />
              ) : note.color}</div>

              <div>
  <strong>Owner:</strong>{" "}
  {editModeId === note.id ? (
    <input
      type="text"
      value={editedNoteData.owner || ""}
      onChange={(e) =>
        setEditedNoteData({ ...editedNoteData, owner: e.target.value })
      }
    />
  ) : (
    highlightWithFuzzy(note.owner || "N/A", search)
  )}
</div>


              <div><strong>Narrative:</strong> {editModeId === note.id ? (
  <textarea
    className="wide-textarea"
    name="narrative"
    value={editedNoteData.narrative || ''}
    onChange={e => setEditedNoteData(f => ({ ...f, narrative: e.target.value }))}
  />
) : (
  <span>{highlightWithFuzzy(note.narrative || '', note, 'narrative')}</span>
)}</div>

	{/* 📸 Attached Photos */}
{Array.isArray(note.photoUrls) && note.photoUrls.length > 0 && (
  <div style={{ marginTop: "10px" }}>
    <strong>Attached Photos:</strong>
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "6px" }}>
      {note.photoUrls.map((url, i) => (
        <div
          key={i}
          style={{
            width: "120px",
            height: "120px",
            overflow: "visible",
            borderRadius: "6px",
            border: "1px solid #ccc",
            cursor: "pointer",
            position: "relative",
          }}
         onClick={(e) => {
 	 e.stopPropagation();
 	 setModalImage(url);
	}}
        >
          <img
            src={url}
            alt={`Attachment ${i + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
          {editModeId === note.id && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();

                setEditedNoteData((prev) => ({
                  ...prev,
                  photoUrls: prev.photoUrls.filter((_, idx) => idx !== i),
                }));
              }}
              style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                background: "rgba(0,0,0,0.6)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "22px",
                height: "22px",
                cursor: "pointer",
                fontWeight: "bold",
                zIndex: 5,
                opacity: 0.8,
              }}
              title="Remove photo"
            >
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  </div>
)}


            </>
          )}

          {/* PLACE */}
          {note.type === 'Place' && (
            <>
          <div><strong>Address:</strong> {editModeId === note.id ? (
  <>
    <input
      value={editedNoteData.streetAddress || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, streetAddress: e.target.value }))}
      placeholder="Street Address"
      style={{ display: 'block', marginBottom: '4px' }}
    />
    <input
      value={editedNoteData.city || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, city: e.target.value }))}
      placeholder="City"
      style={{ display: 'block', marginBottom: '4px' }}
    />
    <input
      value={editedNoteData.addressState || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, addressState: e.target.value }))}
      placeholder="State"
      style={{ display: 'block', marginBottom: '4px' }}
    />
    <input
      value={editedNoteData.addressZip || ''}
      onChange={e => setEditedNoteData(f => ({ ...f, addressZip: e.target.value }))}
      placeholder="Zip"
      style={{ display: 'block' }}
    />
  </>
) : (
  <>
    {highlightWithFuzzy(note.streetAddress || '', note, 'streetAddress')}, {' '}
    {highlightWithFuzzy(note.city || '', note, 'city')}, {' '}
    {highlightWithFuzzy(note.addressState || '', note, 'addressState')} {' '}
    {highlightWithFuzzy(note.addressZip || '', note, 'addressZip')}
  </>
)}</div>



              <div>
  <strong>Owner:</strong>{" "}
  {editModeId === note.id ? (
    <input
      type="text"
      value={editedNoteData.owner || ""}
      onChange={(e) =>
        setEditedNoteData({ ...editedNoteData, owner: e.target.value })
      }
    />
  ) : (
    highlightWithFuzzy(note.owner || "N/A", searchQuery)
  )}
</div>


             <div>
  <strong>Occupants:</strong>{" "}
  {editModeId === note.id ? (
    <>
      {(editedNoteData.occupants || []).map((occ, i) => (
        <input
          key={i}
          value={occ}
          placeholder={`Occupant #${i + 1}`}
          onChange={(e) => {
            const updated = [...editedNoteData.occupants];
            updated[i] = e.target.value;
            setEditedNoteData((f) => ({ ...f, occupants: updated }));
          }}
        />
      ))}
      <button
        onClick={() =>
          setEditedNoteData((f) => ({
            ...f,
            occupants: [...(f.occupants || []), ""],
          }))
        }
      >
        + Add Occupant
      </button>
    </>
  ) : (
    (note.occupants || []).map((occ, i) => (
      <span key={i}>
        {i > 0 && ", "}
        {highlightWithFuzzy(occ || '', note, 'occupants')}
      </span>
    ))
  )}
</div>


              <div><strong>Narrative:</strong> {editModeId === note.id ? (
  		 <textarea
                  className="wide-textarea"
                  name="narrative"
                  value={editedNoteData.narrative || ''}
                  onChange={e => setEditedNoteData(f => ({ ...f, narrative: e.target.value }))} />
) : highlightWithFuzzy(note.narrative || "", note, 'narrative')}</div>

	{/* 📸 Attached Photos */}
{Array.isArray(note.photoUrls) && note.photoUrls.length > 0 && (
  <div style={{ marginTop: "10px" }}>
    <strong>Attached Photos:</strong>
    <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", marginTop: "6px" }}>
      {note.photoUrls.map((url, i) => (
        <div
          key={i}
          style={{
            width: "120px",
            height: "120px",
            overflow: "visible",
            borderRadius: "6px",
            border: "1px solid #ccc",
            cursor: "pointer",
            position: "relative",
          }}
         onClick={(e) => {
  	e.stopPropagation();
  	setModalImage(url);
	}}
        >
          <img
            src={url}
            alt={`Attachment ${i + 1}`}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              display: "block",
            }}
          />
          {editModeId === note.id && (
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();

                setEditedNoteData((prev) => ({
                  ...prev,
                  photoUrls: prev.photoUrls.filter((_, idx) => idx !== i),
                }));
              }}
              style={{
                position: "absolute",
                top: "-10px",
                right: "-10px",
                background: "rgba(0,0,0,0.6)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "22px",
                height: "22px",
                cursor: "pointer",
                fontWeight: "bold",
                zIndex: 5,
                opacity: 0.8,
              }}
              title="Remove photo"
            >
              ×
            </button>
          )}
        </div>
      ))}
    </div>
  </div>
)}


            </>
          )}

         <div>
  {note.editedAt?.seconds
    ? `Edited on: ${new Date(note.editedAt.seconds * 1000).toLocaleString()}`
    : note.timestamp?.seconds &&
      `Saved on: ${new Date(note.timestamp.seconds * 1000).toLocaleString()}`
  }
</div>


          {/* OWNER INFO */}

                  {note.ownerName && (
                    <div style={{ marginTop: '4px' }}>
                      <p>
                        <strong>By:</strong>{' '}
                        {note.rank || "N/A"},{' '}
                        <span
                          onClick={() => handleViewProfile(note.ownerId)}
                          style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
                        >
                          {note.ownerName || "Unknown"}
                        </span>
                        {", "}{note.agency || "N/A"}
                      </p>
                    </div>
                  )}

                  <div className="note-action-buttons">
                    {editModeId === note.id ? (
                      <>
                        <button onClick={handleSaveInlineEdit} disabled={isSavingNote}>
                          {isSavingNote ? "Saving..." : "💾 Save"}
                        </button>
                        <button disabled={isSavingNote} onClick={() => {
                          setEditModeId(null);
                          setEditedNoteData(null);
                        }}>❌ Cancel</button>
                      </>
                    ) : (
                      <>
                        {note.ownerId === userId && (
                          <button onClick={(e) => {
                            e.stopPropagation();
                            handleEditNote(note);
                          }}>✏️ Edit</button>
                        )}
                        <button onClick={(e) => {
                          e.stopPropagation();
                          handleWebShareNote(note);
                        }}>📤 Share</button>

                        <button onClick={(e) => {
    			e.stopPropagation();
    			setVisibleCommentNoteId(prev => prev === 			note.id ? null : note.id);
  			}}>  Add Information </button>


                        {note.ownerId === userId && (
                          <button disabled={Boolean(deletingNoteId)} onClick={(e) => {
                            e.stopPropagation();
                            handleDeleteNote(note.id);
                          }}>
                            {deletingNoteId === note.id ? "Deleting..." : "🗑️ Delete"}
                          </button>
			)} 
			<button
  className="additional-button"
  onClick={(e) => {
    e.stopPropagation();
    toggleComments(note.id);

    if (!expandedNotes[note.id]) {
      // Opening → set up listener
      fetchComments(note.id);
    } else {
      // Closing → clean up listener
      if (commentUnsubscribers.current[note.id]) {
        commentUnsubscribers.current[note.id]();
        delete commentUnsubscribers.current[note.id];
      }
    }
  }}
>
  💬 Additional
  {(commentCounts[note.id] || 0) > 0 && (
    <span className="comment-badge">
      {commentCounts[note.id]}
    </span>
  )}
</button>

                  </>
                 )}
              </div>

                  {visibleCommentNoteId === note.id && (
                    <div style={{ marginTop: '12px', paddingTop: '8px', borderTop: '1px solid #ccc' }}
onClick={(e) => e.stopPropagation()} 
>
                      <textarea
                        value={newCommentText}
                        onChange={(e) => setNewCommentText(e.target.value)}
                        placeholder="Add a comment or related experience..."
                        rows={3}
                        style={{ width: '100%', marginBottom: '8px', border: '1px solid #ccc', borderRadius: '4px', padding: '8px' }}
                      />
                    <div style={{ marginBottom: '12px' }}>
  <label style={{ fontWeight: 'bold' }}>Add Warning/Flag:</label>
  <select
    onChange={(e) => {
      const selectedCode = e.target.value;
      if (selectedCode && !newCommentFlags.includes(selectedCode)) {
        setNewCommentFlags([...newCommentFlags, selectedCode]);
      }
    }}
    defaultValue=""
    style={{ marginLeft: '8px', padding: '6px', borderRadius: '4px' }}
  >
    <option value="" disabled>Select a flag...</option>
    {allFlagOptions.map((flag) => (
      <option key={flag.code} value={flag.code}>
        {flag.code} - {flag.description}
      </option>
    ))}
  </select>



	<div style={{ marginTop: '0.5rem' }}>
  <div style={{ marginBottom: '0.5rem' }}>
    <input
      type="text"
      placeholder="Custom code (4 letters)"
      value={commentCustomCode}
      maxLength={4}
      onChange={(e) => setCommentCustomCode(e.target.value.toUpperCase())}
      style={{ marginRight: '8px' }}
    />
    <input
      type="text"
      pl
      onChange={(e) => setCommentCustomDesc(e.target.value)}
      style={{ marginRight: '8px' }}
    />

    <button onClick={handleAddCustomCommentFlag}>Add</button>

    {(commentCustomCode || commentCustomDesc) && (
      <button
        style={{ marginLeft: '10px', color: 'red' }}
        aceholder="Short description"
      value={commentCustomDesc}onClick={() => {
          setCommentCustomCode('');
          setCommentCustomDesc('');
        }}
      >
        ❌ Clear
      </button>
    )}
  </div>
</div>


  {/* Show selected flags */}
 <div
  style={{
    marginTop: '8px',
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  }}
>
  {newCommentFlags.map((flag, idx) => {
    const code = typeof flag === 'string' ? flag : flag.code;
    const desc =
      typeof flag === 'string'
        ? allFlagOptions.find((f) => f.code === flag)?.description || flag
        : flag.description;

    return (
      <span
        key={idx}
        style={{
          backgroundColor: '#f8d7da',
          color: '#721c24',
          padding: '4px 8px',
          borderRadius: '4px',
          fontWeight: 'bold',
          position: 'relative',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '6px',
        }}
      >
        <span
          onClick={(e) => {
            e.stopPropagation();
            setVisibleDescriptions((prev) => ({
              ...prev,
              [`new-${idx}`]: !prev[`new-${idx}`],
            }));
          }}
          style={{ cursor: 'pointer' }}
        >
          {code}
        </span>

        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            setNewCommentFlags(prevFlags => prevFlags.filter((f, i) => i !== idx));
          }}
          style={{
            background: 'none',
            border: 'none',
            color: '#721c24',
            cursor: 'pointer',
            fontSize: '14px',
            lineHeight: '1',
          }}
        >
          ❌
        </button>

        {visibleDescriptions[`new-${idx}`] && (
          <div
            style={{
              position: 'absolute',
              top: '100%',
              right: 0,
              backgroundColor: '#fff',
              color: '#000',
              padding: '4px 6px',
              borderRadius: '4px',
              fontSize: '12px',
              zIndex: 1000,
              boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
              marginTop: '4px',
              whiteSpace: 'nowrap'
            }}
            onClick={(e) => e.stopPropagation()}
          >
            {desc}
          </div>
        )}
      </span>
    );
  })}
</div>
</div>

                   <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
  <button
    onClick={() => handleSubmitComment(note)}
    disabled={Boolean(commentSubmittingNoteId)}
    style={{
      padding: '6px 12px',
      backgroundColor: '#007bff',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    }}
  >
    {commentSubmittingNoteId === note.id ? "Posting..." : "Submit"}
  </button>

  <button
    onClick={() => setVisibleCommentNoteId(null)}
    style={{
      padding: '6px 12px',
      backgroundColor: '#ccc',
      color: '#333',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    }}
  >
    Cancel
  </button>
</div>

</div> 
                  )}

{expandedNotes[note.id] && (  // only show comments if expanded
  (noteComments[note.id] || []).length > 0 && (
    <div className="comment-wrapper">

      <strong>Additional:</strong>
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        {noteComments[note.id].map((c, i) => (


    <li
  key={i}
  style={{
    marginBottom: '12px',
    paddingBottom: '8px',
    paddingLeft: '30px',
    borderBottom: '1px dashed #aaa',
  }}
>
  <div
    style={{
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '4px',
    }}
  >
    <div>
     <strong>
  {c.rank || "N/A"},{" "}
  <span
    onClick={() => handleViewProfile(c.ownerId)}
    style={{ color: '#007bff', cursor: 'pointer', textDecoration: 'underline' }}
  >
    {c.ownerName || "Unknown"}
  </span>
  {", "}
  {c.agency || "N/A"}
</strong>
{' '}
      -{' '}
      {c.editedAt
  ? `edited ${(c.editedAt.toDate?.() || new Date(c.editedAt)).toLocaleString()}`
  : (c.timestamp?.seconds
      ? new Date(c.timestamp.seconds * 1000).toLocaleString()
      : "Just now")}


    </div>

    {/* FLAGS - tap-to-toggle descriptions for mobile */}
    {c.flags?.length > 0 && (
  <div
    style={{
      display: 'flex',
      gap: '6px',
      flexWrap: 'nowrap',             // ✅ prevent wrapping
      justifyContent: 'flex-end',
      overflow: 'hidden',             // ✅ avoid vertical expansion
      textOverflow: 'ellipsis',       // ✅ truncate if needed
      whiteSpace: 'nowrap',           // ✅ keep in one line
    }}
  >

        {c.flags.map((flag, idx) => {
          const code = typeof flag === 'string' ? flag : flag.code;
          const desc = typeof flag === 'string' ? '' : flag.description;

          return (
            <span
              key={idx}
              onClick={(e) => {
   		 e.stopPropagation();
                const updated = { ...visibleDescriptions };
                updated[`${i}-${idx}`] = !updated[`${i}-${idx}`];
                setVisibleDescriptions(updated);
              }}
              style={{
                backgroundColor: 'red',
                color: 'white',
                padding: '2px 6px',
                borderRadius: '4px',
                fontSize: '12px',
                fontWeight: 'bold',
                cursor: 'pointer',
              }}
            >
              {highlightWithFuzzy(code, search)}
              {visibleDescriptions[`${i}-${idx}`] && desc && (
                <div
                  style={{
                    marginTop: '4px',
                    backgroundColor: '#fff',
                    color: '#000',
                    padding: '4px 6px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    position: 'absolute',
                    zIndex: 1000,
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                  }}
                >
		{highlightWithFuzzy(desc, search)}
                  {desc}
                </div>
              )}
            </span>
          );
        })}
      </div>
    )}
  </div>

	

 {editingComment?.noteId === note.id && editingComment.index === i ? (
  <>
    <textarea
      value={editedCommentText}
      onChange={(e) => setEditedCommentText(e.target.value)}
      onClick={(e) => e.stopPropagation()}
      rows={2}
      style={{ width: '100%', padding: '6px', marginBottom: '4px' }}
    />

    {/* 🔻 Editable Flags Section */}
    <div style={{ marginTop: '10px' }}>
      <strong>Flags:</strong>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', marginTop: '4px' }}>
        {(editedCommentFlags || []).map((flag, idx) => {
          const code = typeof flag === 'string' ? flag : flag.code;
          const desc =
            typeof flag === 'string'
              ? allFlagOptions.find((f) => f.code === flag)?.description || flag
              : flag.description;

          return (
            <span
              key={idx}
              onClick={(e) => {
                e.stopPropagation();
                setVisibleDescriptions((prev) => ({
                  ...prev,
                  [`edit-${idx}`]: !prev[`edit-${idx}`],
                }));
              }}
              style={{
                backgroundColor: '#f8d7da',
                color: '#721c24',
                padding: '4px 8px',
                borderRadius: '4px',
                fontWeight: 'bold',
                position: 'relative',
                cursor: 'pointer',
              }}
            >
              {code}
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  const updated = [...editedCommentFlags];
                  updated.splice(idx, 1);
                  setEditedCommentFlags(updated);
                }}
                style={{ marginLeft: '6px', background: 'transparent', border: 'none', cursor: 'pointer' }}
              >
                ❌
              </button>

              {visibleDescriptions[`edit-${idx}`] && (
                <div
                  style={{
                    position: 'absolute',
                    top: '100%',
                    right: 0,
                    backgroundColor: '#fff',
                    padding: '4px 6px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
                    zIndex: 1000,
                  }}
                >
                  {desc}
                </div>
              )}
            </span>
          );
        })}
      </div>
    </div>

    <button disabled={isSavingComment} onClick={(e) => {
      e.stopPropagation();
      handleSaveEditedComment();
    }} style={{ marginRight: '8px' }}>
      {isSavingComment ? "Saving..." : "💾 Save"}
    </button>
    <button disabled={isSavingComment} onClick={(e) => {
      e.stopPropagation();
      setEditingComment(null);
    }}>
      ❌ Cancel
    </button>
  </>
) : (
  <div style={{ marginBottom: '4px' }}>{highlightMatches(c.text || "", search)} </div>
)}


  {/* Edit/Delete Buttons */}
{c.ownerId === userId && (
  <div style={{ marginTop: '6px' }}>
    <button
  disabled={Boolean(deletingCommentId)}
  onClick={(e) => {
    e.stopPropagation();
    handleEditComment(note.id, i);
  }}
      style={{
        marginRight: '8px',
        padding: '4px 8px',
        fontSize: '12px',
        borderRadius: '4px',
        border: '1px solid #007bff',
        backgroundColor: 'white',
        color: '#007bff',
        cursor: 'pointer'
      }}
    >
      ✏️ Edit
    </button>
    <button
  onClick={(e) => {
    e.stopPropagation();
    handleDeleteComment(note.id, c.id);
  }}
      style={{
        padding: '4px 8px',
        fontSize: '12px',
        borderRadius: '4px',
        border: '1px solid red',
        backgroundColor: 'white',
        color: 'red',
        cursor: 'pointer'
      }}
    >
      {deletingCommentId === c.id ? "Deleting..." : "🗑️ Delete"}
    </button>
  					</div>
				       )}
				   </li>
     			         ))}
                              </ul>
 			   </div>
			   )
			)}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
)}
      {!modalVisible && !editModalVisible && (
        <button className="add-note-btn" onClick={() => setModalVisible(true)}>+ New Entry</button> )}

      {modalVisible && (
        <div className="note-modal">
          <div className="note-form">

	

	<div style={{ display: 'flex', justifyContent: 'center', marginBottom: '1rem' }}>
  {['Person', 'Vehicle', 'Place'].map((t) => (
    <button
      key={t}
      onClick={() => setTab(t)}
      style={{
        margin: '0 8px',
        padding: '8px 16px',
        borderRadius: '6px',
        border: tab === t ? '2px solid #007bff' : '1px solid #ccc',
        backgroundColor: tab === t ? '#e7f1ff' : '#f8f9fa',
        cursor: 'pointer'
      }}
    >
      {t}
    </button>
  ))}
</div>
<h2 style={{ textAlign: 'center', marginBottom: '1rem' }}>New {tab} Entry</h2>

<div
  className="acceptable-use-reminder"
  style={{
    marginBottom: '12px',
    backgroundColor: '#e8f5e9',
    border: '2px solid #2e7d32',
    borderRadius: '8px',
    padding: '12px 16px',
    color: '#040811',
    lineHeight: '1.6',
  }}
>
  <div style={{ fontWeight: 'bold', color: '#2e7d32' }}>
    ✅ Acceptable Use Reminder
  </div>

  <div style={{ marginTop: '6px' }}>
    You may enter <strong>personally obtained information</strong> such as a subject’s
    name, address, phone number, driver’s license number, or date of birth,
    <strong> if it was gathered directly from the individual during an encounter.</strong>
  </div>

  {/* ⚠️ Highlighted warning line */}
  <div
    style={{
      marginTop: '8px',
      color: '#000',
      backgroundColor: '#ffebee',
      border: '1px solid #d32f2f',
      borderRadius: '6px',
      padding: '8px 10px',
      fontWeight: 'bold',
    }}
  >
    <span style={{ color: '#d32f2f' }}>⚠️ Do <strong>NOT</strong></span> include or reference any data retrieved from
    <span style={{ color: '#000' }}>
      <strong> NCIC, NLETS, CJLEADS, DMV, or other CJIS-regulated systems.</strong>
    </span>
  </div>

  <div style={{ marginTop: '6px' }}>
    Entries should describe <strong>firsthand observations or interactions</strong>
    for officer safety and situational awareness — not official records or database results.
  </div>
</div>

            
            {renderTabFields()}
            <div>
              {/* Flag Section */}
<div style={{ marginTop: '1rem' }}>
  <label><strong>Flags</strong></label>

  <select onChange={handleSelectPredefinedFlag} value="">
    <option value="">-- Select predefined flag --</option>
    {flagOptions[tab].map(f => (
      <option key={f.code} value={f.code}>
        {f.code} – {f.description}
      </option>
    ))}
  </select>


    {/* Custom Flag Inputs */}
  <div style={{ marginTop: '0.5rem' }}>
  <div style={{ marginBottom: '0.5rem' }}>
    <input
      type="text"
      placeholder="Custom code (4 letters)"
      value={customCode}
      maxLength={4}
      onChange={(e) => setCustomCode(e.target.value.toUpperCase())}
      style={{ marginRight: '8px' }}
    />
    <input
  type="text"
  placeholder="Short description"
  value={customDesc}
  onChange={(e) => setCustomDesc(e.target.value)}
  style={{ marginRight: '8px' }}
/>


    <button onClick={handleAddCustomFlag}>Add</button>

    {(customCode || customDesc) && (
      <button
        style={{ marginLeft: '10px', color: 'red' }}
        onClick={() => {
          setCustomCode('');
          setCustomDesc('');
        }}
      >
        ❌ Clear
      </button>
    )}
  </div>

  <ul style={{ marginTop: '0.5rem' }}>
    {formFlags.map((f, i) => (
      <li key={i}>
        <span style={{ color: 'red', fontWeight: 'bold' }}>{f.code}</span>: {f.description}
        <button onClick={() => handleRemoveFlag(i)} style={{ marginLeft: '8px' }}>❌</button>
      </li>
    ))}
  </ul>
</div>
</div>

	{/* 📸 Attach Photos */}
<div style={{ marginTop: "16px", marginBottom: "20px" }}>
  <label><strong>Attach Photos:</strong></label>
  <input
    type="file"
    accept="image/*,.pdf,.doc,.docx,.txt"
    multiple
    onChange={(e) => {
      const files = Array.from(e.target.files);
      setSelectedFiles((prev) => [...prev, ...files]);
      const newPreviews = files.map((f) => URL.createObjectURL(f));
      setPreviewUrls((prev) => [...prev, ...newPreviews]);
    }}
  />
</div>

{previewUrls.length > 0 && (
  <div
    style={{
      display: "flex",
      flexWrap: "wrap",
      gap: "8px",
      marginTop: "6px",
      marginBottom: "20px",
    }}
  >
    {previewUrls.map((src, i) => {
      const fileType = src.split(".").pop().toLowerCase();

      const isImage = ["jpg", "jpeg", "png", "gif", "bmp", "webp"].includes(fileType);
      const isDocument = ["pdf", "doc", "docx", "txt"].includes(fileType);

      return (
        <div key={i} style={{ position: "relative", textAlign: "center" }}>
          {isImage ? (
            <img
              src={src}
              alt={`Preview ${i + 1}`}
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "6px",
                border: "1px solid #ccc",
                cursor: "pointer",
              }}
              onClick={() => {
                setSelectedPreviewUrl(src);
                setSelectedPreviewType("image");
              }}
              title="Click to preview"
            />
          ) : (
           <div
  onClick={() => {
    setSelectedPreviewUrl(src);
    setSelectedPreviewType("document");
  }}
  style={{
    width: "100px",
    height: "100px",
    borderRadius: "6px",
    border: "1px solid #ccc",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    background: "#f7f7f7",
    cursor: "pointer",
    padding: "6px",
  }}
  title="Click to preview document"
>
  <span style={{ fontSize: "26px", marginBottom: "4px" }}>📄</span>
  <span
    style={{
      fontSize: "11px",
      textAlign: "center",
      color: "#333",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      width: "90px",
    }}
  >
    {src.split("/").pop().split("?")[0].substring(0, 12)}…
  </span>
</div>

          )}

          <button
            type="button"
            onClick={() => {
              setSelectedFiles((prev) => prev.filter((_, idx) => idx !== i));
              setPreviewUrls((prev) => prev.filter((_, idx) => idx !== i));
            }}
            style={{
              position: "absolute",
              top: "-6px",
              right: "-6px",
              background: "rgba(0,0,0,0.6)",
              color: "white",
              border: "none",
              borderRadius: "50%",
              width: "20px",
              height: "20px",
              cursor: "pointer",
              fontWeight: "bold",
              lineHeight: "16px",
            }}
            title="Remove"
          >
            ×
          </button>
        </div>
      );
    })}
  </div>
)}


              <button className="save-btn" onClick={handleAddNote} disabled={isCreatingNote}>
                {isCreatingNote ? "Saving..." : "Save"}
              </button>
              <button className="cancel-btn" disabled={isCreatingNote} onClick={() => {
                setModalVisible(false);
                setCustomFlag({ code: '', description: '' });
              }}>❌ Cancel</button>
            </div>
          </div>
        </div>
      )}

	{selectedPreviewUrl && (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0,0,0,0.8)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 9999,
      flexDirection: "column",
    }}
  >
    <div
      style={{
        background: "white",
        padding: "10px",
        borderRadius: "8px",
        maxWidth: "90%",
        maxHeight: "85%",
        overflow: "hidden",
      }}
    >
      {selectedPreviewType === "image" ? (
        <img
          src={selectedPreviewUrl}
          alt="Preview"
          style={{ width: "100%", maxHeight: "80vh", objectFit: "contain" }}
        />
      ) : (
       <iframe
  src={`https://docs.google.com/gview?embedded=true&url=${encodeURIComponent(selectedPreviewUrl)}`}
  style={{ width: "80vw", height: "80vh", border: "none" }}
  title="Document Preview"
  allowFullScreen
></iframe>

      )}
    </div>

    <button
      onClick={() => {
        setSelectedPreviewUrl(null);
        setSelectedPreviewType(null);
      }}
      style={{
        marginTop: "10px",
        background: "#1976d2",
        color: "white",
        border: "none",
        borderRadius: "4px",
        padding: "8px 14px",
        cursor: "pointer",
        fontSize: "14px",
      }}
    >
      Close Preview
    </button>
  		</div>
		)}
	{modalImage && (
  <div
    className="image-preview-overlay"
    onClick={() => setModalImage(null)}
  >
    <div
      className="image-preview-container"
      onClick={(e) => e.stopPropagation()}
    >
      <img src={modalImage} alt="Preview" className="image-preview-full" />

      <button
        className="download-btn"
        onClick={async () => {
          try {
            const result = await saveToGallery(modalImage, { fileName: `database_${Date.now()}.jpg` });
            alert(formatSaveMessage(result));
          } catch (err) {
            console.error('Save failed:', err);
            alert('Error: ' + (err.message || JSON.stringify(err)));
          }
        }}
      >
        ⬇ Save
      </button>

      <button className="close-btn" onClick={() => setModalImage(null)}>
        ✖
      </button>
   		 </div>
  	      </div>
             )}
	<ToastContainer />
    </div>
  </>
);
}
